import React, { useEffect, useState } from "react";
import { Modal, notification } from "antd";
import UploadBox from "../../components/UploadBox";
import InputBox from "../../components/InputBox";

const openNotification = () => {
  notification.success({
    message: "Success!",
    description: "GRN Number Edited!!!",
    onClick: () => {
      console.log("Notification Clicked!");
    },
  });
};

const EditGRNForm = ({
  visible,
  setVisible,
  onSave,
  grn,
  grnFile,
  orderId,
}) => {
  const [grnNumber, setGrnNumber] = useState("");
  const [grnFileRef, setGrnFileRef] = useState("");
  const [grnFileError, setGrnFileError] = useState(null);
  const [fileSizeError, setFileSizeError] = useState(false);

  useEffect(() => {
    setGrnNumber(grn);
    if (grnFile)
      setGrnFileRef({
        name: grnFile.split("/")[grnFile.split("/").length - 1].split("_")[1],
      });
  }, [setGrnNumber, setGrnFileRef, grn, grnFile]);

  const handleSuccess = () => {
    setVisible(false);
    setGrnNumber("");
    setGrnFileRef("");
    openNotification();
    setFileSizeError(false);
  };

  const handleFailure = () => {
    console.log("An error occured");
    setVisible(false);
    setGrnNumber("");
    setGrnFileRef("");
    setGrnFileError(null);
    setFileSizeError(false);
  };

  const handleFileUpload = (e) => {
    if (e?.target?.files[0]?.type !== "application/pdf") {
      setGrnFileError(true);
      setGrnFileRef(null);
      return;
    }
    if (e.target.files[0]?.size > 12 * 1024 * 1024) {
      setFileSizeError(true);
      return;
    }
    setGrnFileError(null);
    setGrnFileRef(null);
    const files = e.target.files;
    if (files.length) {
      const fileToUpload = files[0];
      setGrnFileRef(fileToUpload);
    }
  };

  const onSubmit = () => {
    let check = {
      updateGrnNumber: false,
      updateGrnFile: false,
    };

    if (grnNumber !== grn) check.updateGrnNumber = true;
    if (grnFileRef.lastModified) check.updateGrnFile = true;

    const payloadData = {
      grnNumber,
      grnFileRef,
      check,
    };

    const payload = {
      onSuccess: handleSuccess,
      data: payloadData,
      onFailure: handleFailure,
    };

    onSave(payload);
  };

  const handleCancel = () => {
    setVisible(false);
    setGrnFileError(null);
    setGrnNumber(grn);
    setGrnFileRef({
      name: grnFile.split("/")[grnFile.split("/").length - 1].split("_")[1],
    });
    setFileSizeError(false);
  };

  return (
    <Modal
      title={`Edit GRN`}
      visible={visible}
      okText="Submit"
      onOk={onSubmit}
      okButtonProps={{ disabled: !grnNumber || !grnFileRef ? true : false }}
      onCancel={handleCancel}
    >
      <InputBox
        value={grnNumber}
        onChange={(e) => {
          if (e.target.value.trim().length === e.target.value.length) {
            setGrnNumber(e.target.value);
          }
        }}
        label="Enter GRN Number"
      />
      <UploadBox
        value={grnFileRef}
        onChange={(e) => handleFileUpload(e)}
        label="Upload GRN File"
      />
      {grnFileError && (
        <p
          style={{
            color: "red",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Please upload .pdf files only
        </p>
      )}
      {fileSizeError && (
        <p
          style={{
            color: "#ff4d4f",
            fontSize: "14px",
            textAlign: "center",
          }}
        >
          Size of the file exceeds 12 MB. Please try to upload file size less
          than 12 MB
        </p>
      )}
      <p
        style={{
          marginTop: "10px",
          color: "#75797d",
          fontSize: "12px",
          fontStyle: "italic",
        }}
      >
        * Uploaded file size should not exceed more than 12 MB
      </p>
    </Modal>
  );
};

export default EditGRNForm;
